import { SKELETON_CARD_DELAY_SECONDS, SkeletonBar, SkeletonPulse, SkeletonRegion } from "@/components/ui/skeleton";

/**
 * Two rows of cards in shimmer, while the catalog answers a new slice (filters spec §8).
 *
 * The wait is declared rather than hidden: changing a facet, sending a search or turning the
 * page replaces the grid, and an unannounced replacement reads as the screen freezing. The
 * card's own shape — a 4:5 frame, the collection's line, the name and the price — so the grid
 * does not jump when the pieces arrive.
 */

/** Two rows at the grid's widest (three columns), which is what the spec asks for. */
const CARDS = 6;

export function CatalogGridSkeleton() {
  return (
    <SkeletonRegion label="Carregando peças" className="tb-catalogo-grid mt-[clamp(24px,3vw,40px)]">
      {Array.from({ length: CARDS }, (_, index) => (
        <div key={index} className="flex flex-col">
          <SkeletonPulse
            className="aspect-[4/5] w-full rounded-[var(--tb-radius-xs)] bg-[var(--tb-porcelain)]"
            delayIndex={index}
            delayStep={SKELETON_CARD_DELAY_SECONDS}
          />
          <div className="mt-3.5 flex flex-col gap-2">
            <SkeletonBar height={11} width="42%" />
            <SkeletonBar height={14} width="78%" />
            <SkeletonBar height={12} width="34%" />
          </div>
        </div>
      ))}
    </SkeletonRegion>
  );
}
